// @index('./*.ts', f => `export * from '${f.path}';`)
export * from './partner.api';
export * from './stay.api';
// @endindex